<input type="file" class="file-input" [accept]="requiredFileType" (change)="onFileSelected($event)" #fileUpload>

<div class="file-upload">
    <img src="assets/images/uploadr3.png" class="file-img hover-effect" (click)="fileUpload.click()" />
    <span class="file-upload-span">Choose a file from your device to upload</span>
</div>


<div *ngIf="uploadProgress" class="progress mt-3 mb-1">
    <div class="w3-light-grey">
        <div class="w3-green" style="height:24px;width:25%"></div>
    </div>
    {{uploadProgress}}%
</div>
<div *ngIf="uploadProgress">
    <div class="container mt-0 text-center">
        <div>
            <span *ngIf="visibleIndex !== -1" class="bold-text">
              {{ texts[visibleIndex] }}
          </span>
        </div>
    </div>
</div>






{{responseData}}